import { CONTRACT_BLOCK_ACTION_MODE } from "interfaces";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { CustomButton } from "ui";

import { ContractBlockActionModal } from "./ContractBlockActionModal";

export const BlockContractBtn = observer(() => {
  const { actionModals } = useStores();

  const openBlockContractModal = () => {
    actionModals.open(() => <ContractBlockActionModal mode={CONTRACT_BLOCK_ACTION_MODE.BLOCK} />, {
      width: "600px",
      noValidation: true,
      isOverlayClose: false,
      title: "Укажите причину блокировки",
      onApply: () => Promise.resolve(),
    });
  };

  return (
    <CustomButton type="default" tooltip="Заблокировать договор" onClick={openBlockContractModal}>
      Заблокировать
    </CustomButton>
  );
});
